export default "__VITE_ASSET__CxRy0RRL__"